var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Grid, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import cloneDeep from 'lodash';
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import HeaderCatalogPageComponent from "../../../components/templates/headerCatalogPageUpdated";
import { ESystemName, LOCAL_STORAGE_KEYS } from "../../../constants";
import { resetState } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import { secondaryTextGray } from "../../../theme/palette";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate } from "../../../utils/utils";
import { DownloadIconSVG, PrintIconSVG, ShareOutlinedIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { FilterPW } from "../components/filterPW";
import { proprietaryWarrantyGetAPICall, proprietaryWarrantyPagingAPICall } from "../services/apiCall";
import { ProprietaryWarrantyKeys, proprietaryWarrantyPagingAPI, ProprietaryWarrantyResetKeys, viewTypeOptions } from "../services/entity";
import CardView from "./proprietaryCardView";
var ProprietaryWarranty = function () {
    var _crud$filterValue, _crud$ProprietaryWarr;
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = useState('list'), activeView = _a[0], setActiveView = _a[1];
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _b = useState(false), isFilterOpen = _b[0], setFilterOpen = _b[1];
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var filterValue = (_crud$filterValue = crud['filterValue']) === null || _crud$filterValue === void 0 ? void 0 : _crud$filterValue.data;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var menuFeatures = cloneDeep(storedMenuFeatures);
    var list = menuFeatures === null || menuFeatures === void 0 ? void 0 : menuFeatures.filter(function (data) { return !(data.Name == 'Cancel' || data.Name == 'Edit'); });
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var getIcon = function (name) {
        switch (name) {
            case 'Print':
                return /*#__PURE__*/ React.createElement(PrintIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'DownloadPDF':
                return /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Share':
                return /*#__PURE__*/ React.createElement(ShareOutlinedIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    };
    console.log('activeView---', activeView);
    var handleRowClick = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            proprietaryWarrantyGetAPICall({
                request: {
                    id: id
                }
            });
            navigate("./createProprietaryWarranty/".concat(id, "?mode=edit"));
            return [2 /*return*/];
        });
    }); };
    var handleClickFilterIcon = function () {
        setFilterOpen(function (prev) { return !prev; });
    };
    var pagingColumns = [{
            field: 'SrNo',
            headerName: 'Sr No.',
            valueFormatter: function (val, row, col, api) { return api.current.getRowIndexRelativeToVisibleRows(row === null || row === void 0 ? void 0 : row.id) + 1; },
            minWidth: 100
        }, {
            field: 'DocumentNo',
            headerName: 'Document No.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocumentNo ? "".concat(row === null || row === void 0 ? void 0 : row.DocumentNo) : '-'; },
            minWidth: 200
        }, {
            field: 'DocumentName',
            headerName: 'Document Name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocumentName ? "".concat(row === null || row === void 0 ? void 0 : row.DocumentName) : '-'; },
            minWidth: 200
        }, {
            field: 'CustomerName ',
            headerName: 'Customer name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CustomerName ? "".concat(row === null || row === void 0 ? void 0 : row.CustomerName) : '-'; },
            minWidth: 200
        }, {
            field: 'Mobile',
            headerName: 'Mobile',
            minWidth: 200
        }, {
            field: 'RegistrationNo',
            headerName: 'Registration No.',
            minWidth: 200
        }, {
            field: 'ClaimSettlementDate ',
            headerName: 'Claim settlement date ',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ClaimSettlementDate ? dateFormate(row === null || row === void 0 ? void 0 : row.ClaimSettlementDate) : '-'; },
            minWidth: 200
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                var _params$row;
                var data = (params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.StatusName) === 'Cancelled' ? list : storedMenuFeatures;
                return data === null || data === void 0 ? void 0 : data.map(function (data) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    label: data === null || data === void 0 ? void 0 : data.DisplayName,
                    icon: getIcon(data === null || data === void 0 ? void 0 : data.Name),
                    divider: (data === null || data === void 0 ? void 0 : data.Name) === 'Edit',
                    id: "action-icon",
                    showInMenu: true
                }); });
            },
            minWidth: 50
        }];
    var _c = useState(viewTypeOptions.length > 0 && isAllViewActive ? viewTypeOptions[0] : viewTypeOptions[1]), selectedListVariant = _c[0], setSelectedListVariant = _c[1];
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    useEffect(function () {
        proprietaryWarrantyPagingAPICall({
            key: ProprietaryWarrantyKeys.Paging,
            request: getRequest(),
            url: proprietaryWarrantyPagingAPI
        });
    }, [selectedListVariant, filterValue]);
    var getRequest = function () {
        var _getLocalStorageItem;
        var request = _objectSpread({
            IdentityId: selectedListVariant === "My proprietary warranty" ? (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.IdentityId : undefined
        }, filterValue);
        return request;
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        items: viewTypeOptions
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            margin: {
                xs: '28px 0px 16px 0px !important',
                sm: '0px 0px 0px 0px !important'
            }
        }
    }, /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent, {
        handleClickFilterIcon: handleClickFilterIcon,
        selectedMenuItem: selectedListVariant,
        menus: (viewTypeOptions === null || viewTypeOptions === void 0 ? void 0 : viewTypeOptions.length) > 0 ? viewTypeOptions : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: (_crud$ProprietaryWarr = crud[ProprietaryWarrantyKeys.Paging]) === null || _crud$ProprietaryWarr === void 0 ? void 0 : _crud$ProprietaryWarr.count,
        onClickCreateModule: function () {
            dispatch(resetState(ProprietaryWarrantyResetKeys));
            navigate('./createProprietaryWarranty?mode=add');
        },
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.ProprietaryWarranty,
        pagingKey: ProprietaryWarrantyKeys.Paging
    })), activeView === 'list' && isDesktop && /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: ProprietaryWarrantyKeys.Paging,
        getPagingData: proprietaryWarrantyPagingAPICall,
        pagingAPIRequest: getRequest(),
        columns: pagingColumns,
        dataGridProps: {
            onCellClick: function (params) {
                if (!(params.field == 'actions')) {
                    handleRowClick(params === null || params === void 0 ? void 0 : params.id);
                }
            },
            disableColumnMenu: false
        }
    })), (activeView === 'grid' || IS_MOBILE) && /*#__PURE__*/ React.createElement(Box, {
        py: 2
    }, /*#__PURE__*/ React.createElement(CardView, {
        pagingApiCall: proprietaryWarrantyPagingAPICall,
        pagingKey: ProprietaryWarrantyKeys.Paging,
        pagingRequest: getRequest(),
        pageSize: 20,
        cardMapper: function (data) {
            return {
                id: "card-".concat(data.id),
                docNo: data.DocumentNo,
                title: data.DocumentName,
                details: [{
                        label: "Customer",
                        value: data === null || data === void 0 ? void 0 : data.CustomerName
                    }, {
                        label: "Registration no:",
                        value: data === null || data === void 0 ? void 0 : data.RegistrationNo
                    }, {
                        label: "Claim settlement date :",
                        value: dateFormate(data === null || data === void 0 ? void 0 : data.ClaimSettlementDate)
                    }]
            };
        },
        callIconVisibleFor: 'Customer',
        actionsMenu: menuFeatures,
        menuIcons: getIcon,
        onCardClick: handleRowClick
    })), /*#__PURE__*/ React.createElement(FilterPW, {
        isFilterOpen: isFilterOpen,
        setFilterOpen: handleClickFilterIcon
    }));
};
export default ProprietaryWarranty;
